import React from 'react';
import { motion } from 'framer-motion';
import { useSFX } from 'js/hooks/useSFX';

export default function ButtonToggle({
  labels = { false: 'No', true: 'Yes' },
  selected = false,
  onToggle,
  disabled = false,
}) {
  const { playSFX } = useSFX();
  return (
    <button
      className={'button--toggle button--toggle__container' + (selected ? ' button--toggle--selected' : '')}
      style={{
        justifyContent: 'flex-' + (selected ? 'end' : 'start'),
      }}
      onClick={() => {
        playSFX('button_tap');
        !disabled && onToggle(!selected);
      }}
      disabled={disabled}
    >
      <motion.span
        className="button--toggle__label"
        transition={{
          type: 'spring',
          visualDuration: 0.5,
          bounce: 0.2,
        }}
        initial={{ x: `calc(-50% - ${selected ? 20 : -20}px)`, y: '-50%', opacity: [1, 0, 1] }}
        animate={{ x: `calc(-50% - ${selected ? 20 : -20}px)`, y: '-50%', opacity: [1, 0, 1] }}
        style={{ top: '50%', left: '50%' }}
      >
        {labels[selected]}
      </motion.span>
      <motion.div
        className="button--toggle button--toggle__handle"
        layout
        transition={{
          type: 'spring',
          visualDuration: 0.2,
          bounce: 0.2,
        }}
      />
    </button>
  );
}
